import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hrApi } from '../../api/hr.js';

const initial = {
  name: '',
  email: '',
  password: '',
  employeeCode: '',
  departmentId: '',
  positionId: '',
  managerId: '',
  hireDate: new Date().toISOString().slice(0, 10),
  employmentType: 'full_time',
  status: 'active',
  phone: '',
  emergencyContact: '',
};

export default function EmployeeNew() {
  const nav = useNavigate();
  const [form, setForm] = useState(initial);
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);
  const [managers, setManagers] = useState([]);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    Promise.all([hrApi.listDepartments(), hrApi.listPositions(), hrApi.listEmployees({ limit: 200 })])
      .then(([d, p, e]) => {
        setDepartments(d?.items || []);
        setPositions(p?.items || []);
        setManagers(e?.items || []);
      })
      .catch(() => {});
  }, []);

  function set(k, v) { setForm((f) => ({ ...f, [k]: v })); }

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const payload = { ...form };
    for (const k of Object.keys(payload)) if (payload[k] === '') delete payload[k];
    try {
      const result = await hrApi.createEmployee(payload);
      nav(`/hr/employees/${result.employee.id}`);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not create');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="card form-card">
      <header className="page-header"><h1>New Employee</h1></header>
      <form onSubmit={submit} className="grid-form">
        <label>Name<input value={form.name} onChange={(e) => set('name', e.target.value)} required /></label>
        <label>Email<input type="email" value={form.email} onChange={(e) => set('email', e.target.value)} required /></label>
        <label>Initial Password<input type="text" value={form.password} onChange={(e) => set('password', e.target.value)} placeholder="Leave blank to invite" /></label>
        <label>Employee Code<input value={form.employeeCode} onChange={(e) => set('employeeCode', e.target.value)} required /></label>
        <label>Hire Date<input type="date" value={form.hireDate} onChange={(e) => set('hireDate', e.target.value)} required /></label>
        <label>
          Department
          <select value={form.departmentId} onChange={(e) => set('departmentId', e.target.value)}>
            <option value="">—</option>
            {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </label>
        <label>
          Position
          <select value={form.positionId} onChange={(e) => set('positionId', e.target.value)}>
            <option value="">—</option>
            {positions.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
          </select>
        </label>
        <label>
          Manager
          <select value={form.managerId} onChange={(e) => set('managerId', e.target.value)}>
            <option value="">—</option>
            {managers.map((m) => <option key={m.id} value={m.id}>{m.user_name}</option>)}
          </select>
        </label>
        <label>
          Employment Type
          <select value={form.employmentType} onChange={(e) => set('employmentType', e.target.value)}>
            <option value="full_time">Full-time</option>
            <option value="part_time">Part-time</option>
            <option value="contract">Contract</option>
            <option value="intern">Intern</option>
            <option value="consultant">Consultant</option>
          </select>
        </label>
        <label>Phone<input value={form.phone} onChange={(e) => set('phone', e.target.value)} /></label>
        <label className="full">Emergency Contact<input value={form.emergencyContact} onChange={(e) => set('emergencyContact', e.target.value)} /></label>

        {error && <div className="alert error full">{error}</div>}
        <div className="full actions">
          <button type="button" className="btn ghost" onClick={() => nav(-1)}>Cancel</button>
          <button type="submit" className="btn primary" disabled={submitting}>{submitting ? 'Creating…' : 'Create'}</button>
        </div>
      </form>
    </section>
  );
}
